import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <section id="services" className="services-overview-new">
      <div className="container">
        <div className="section-header-new">
          <h2>Powerful AI Solutions</h2>
          <p>Choose the right AI solution to automate your customer interactions</p>
        </div>
        <div className="services-grid-new">
          <div className="service-card-new">
            <div className="service-icon-new">
              <i className="fas fa-phone"></i>
            </div>
            <h3>AI Voice Agents</h3>
            <p className="service-description">Never miss a call again. Our AI voice agents answer calls, schedule appointments, and handle customer inquiries automatically.</p>
            <div className="service-features-new">
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>24/7 call answering</span>
              </div>
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>Appointment scheduling</span>
              </div>
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>FAQ handling</span>
              </div>
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>Smart call transfer</span>
              </div>
            </div>
            <div className="service-benefits-new">
              <div className="benefit-tag">
                <i className="fas fa-clock"></i>
                <span>Always Available</span>
              </div>
              <div className="benefit-tag">
                <i className="fas fa-dollar-sign"></i>
                <span>Cost Effective</span>
              </div>
            </div>
            <a href="#contact" className="btn-primary-new">
              <i className="fas fa-arrow-right"></i>
              Get Started
            </a>
          </div>
          <div className="service-card-new">
            <div className="service-icon-new">
              <i className="fas fa-comments"></i>
            </div>
            <h3>AI Chatbots</h3>
            <p className="service-description">Provide instant customer support with intelligent chatbots that engage visitors and answer questions automatically.</p>
            <div className="service-features-new">
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>Instant responses</span>
              </div>
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>Product information</span>
              </div>
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>Order processing</span>
              </div>
              <div className="feature-item-new">
                <i className="fas fa-check-circle"></i>
                <span>Human handoff</span>
              </div>
            </div>
            <div className="service-benefits-new">
              <div className="benefit-tag">
                <i className="fas fa-rocket"></i>
                <span>Instant Support</span>
              </div>
              <div className="benefit-tag">
                <i className="fas fa-globe"></i>
                <span>Website Integration</span>
              </div>
            </div>
            <a href="#contact" className="btn-primary-new">
              <i className="fas fa-arrow-right"></i>
              Get Started
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
